<!-- <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading> -->
@if (feedbackReady$ | async) {
  <app-screen-shell [contentClass]="'container mb-4'" titleKey="navigation.feedback" (back)="goBack()">
    <div class="row my-3 my-md-4">
      <div class="col-12 col-md-10 col-lg-7 mx-auto">
        <p>{{ 'feedback.description' | translate }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-10 col-lg-7 mx-auto">
        <form (ngSubmit)="onSubmit()" autocomplete="off" #feedbackForm="ngForm" [attr.aria-busy]="submitting">
          <div class="form-group">
            <label for="subject" class="mb-0">{{ 'feedback.subject' | translate }}</label>
            <input type="text" class="form-control" id="subject" [placeholder]="'validation.feedbackSubject' | translate" required
              [(ngModel)]="feedback.subject" name="subject" [disabled]="submitting">
          </div>
          <div class="form-group">
            <label for="feedback" class="mb-0">{{ 'navigation.feedback' | translate }}</label>
            <textarea type="text" class="form-control" id="feedback" required [(ngModel)]="feedback.feedback"
              name="feedback" [disabled]="submitting" [placeholder]="'feedback.detailsPlaceholder' | translate"></textarea>
          </div>
          <div class="form-group anonymous-checkbox">
            <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input  cursor-pointer" id="anonymous" [(ngModel)]="feedback.anonymous" name="anonymous" [disabled]="submitting">
              <label class="custom-control-label  cursor-pointer" for="anonymous">{{ 'feedback.anonymous' | translate }}</label>
            </div>
            <!-- <label for="feedback">Anonymous</label>
            <input type="checkbox" class="form-control" id="anonymous" [(ngModel)]="feedback.anonymous" name="anonymous"> -->
          </div>
          @if (submitError) {
            <p role="alert" class="text-danger">{{ submitError | translate }}</p>
          }
          <div class="">
            <div class="row justify-content-end">
              <div class="col-auto pr-0">
                <button type="button" class="btn btn-secondary text-white px-3" (click)="cancelFeedback()" [disabled]="submitting">{{ 'common.cancel' | translate }}</button>
              </div>
              <div class="col-auto ">
                <button type="submit" class="btn btn-primary px-3" [ngClass]="submitting || !feedbackForm.form.valid ? 'disabled' : ''" [disabled]="submitting || !feedbackForm.form.valid">{{ 'common.save' | translate }}</button>
              </div>
            </div>
          </div>
        </form>
        <hr class="my-5">
      </div>
    </div>
    @for (feedback of feedbacks; track feedback; let idx = $index) {
      <div class="row">
        <div class="col-12 col-md-10 col-lg-7 mx-auto mb-4">
          <div class="card bg-light">
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <a href="#" (click)="viewFeedback(idx);$event.preventDefault()" class="no-underline">
                    <strong>{{feedback.subject}}</strong>
                  </a>
                </div>
              </div>
              <div id="feedbackDetails" class="row">
                <div class="col-12">
                  @if (!feedback.anonymous) {
                    <span>by {{feedback.email}}</span>
                  }
                  @if (feedback.anonymous) {
                    <span>{{ 'feedback.anonymous' | translate }}</span>
                  }
                  <span> {{ 'feedback.onDate' | translate:{date: (feedback.createdDate | localizedDate:'short')} }}</span>
                  <br>
                    @if (feedbackVisibility[idx]) {
                      <p>{{feedback.feedback}}</p>
                    }
                  </div>
                </div>
              </div>
            </div><!-- /.card   -->
          </div>
        </div>
      }
    </app-screen-shell>
  }
